import React, { ChangeEvent } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Option, OptionValue } from './types';

const loaderStyle = {
  position: 'absolute',
  right: '3.5rem',
};

type Props<T> = Omit<TextFieldProps, 'onChange'> & {
  onChange?: (value: T) => void;
  options?: Option<T>[];
  value?: T;
  loading?: boolean;
};
function SelectOption<T extends OptionValue>({
  value = '' as T,
  options = [],
  onChange,
  loading,
  ...rest
}: Props<T>) {
  const noOptions = !options.length;
  const handleClick = (event: ChangeEvent<HTMLInputElement>) =>
    onChange && onChange(event.target.value as T);

  return (
    <TextField
      select
      onChange={handleClick}
      value={value}
      InputProps={{
        endAdornment: loading && (
          <CircularProgress size="2.3rem" sx={loaderStyle} />
        ),
      }}
      {...rest}
    >
      {noOptions && <MenuItem disabled>No available options</MenuItem>}
      {loading && <MenuItem disabled>Loading...</MenuItem>}
      {options.map(({ label, id }) => (
        <MenuItem key={id} value={id}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default SelectOption;
